import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ConfirmationModal } from "../../components/Modal/ConfirmationModal";
import { useNavigate } from "react-router-dom";
import {
  showAllCohort,
  getAllCohortHospital,
  deleteNervePost,
} from "../../redux/admin/actions/admin.actions";
import { LinearLoader } from "../../components/Loader/LinearLoader";
import { SyncOutlined } from "@ant-design/icons";
import { Table } from "react-bootstrap";
import style from "./Notify.module.scss";
import { PlusOutlined } from "@ant-design/icons";
import CreateForm from "./CreateForm";
import axiosClient from "../../service/axios";

const NotifyNerveScreen = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [dataItem, setDataItem] = useState({});
  const [createModal, setCreateModal] = useState();
  const [isDeleted, setIsDeleted] = useState(false);
  const [dataUpdated, setDataUpdated] = useState(false);

  const [refId, setrefId] = useState("");

  const dispatch = useDispatch();
  const { allHospitalCohort } = useSelector((state) => state.adminReducer);


  useEffect(() => {
    setLoading(true);
    dispatch(getAllCohortHospital());
    setLoading(false);
  }, [dispatch, dataUpdated]);

  const headers = [
    { key: "id", label: "ID" },
    { key: "name", label: "Name" },
    { key: "date", label: "Date" },
    { key: "remove/update", label: "Remove/Update"}
  ];

  const handleSuccessPost = () => {
    // Perform your post logic here

    // Set dataUpdated to true to trigger data refresh
    setDataUpdated(true);
  };

  const handleRow = async (item) => {
    const response = await axiosClient.delete(
      `/lite/v2/api/admin/hospital/cohort/delete/${item.id}`,
      item.name
    );

    // const { ref_id, title, message, id } = item;
    // const formData = {
    //   ref_id: ref_id,
    //   id: id,
    //   title: title,
    //   message: message,
    // };
    // setDataItem(formData);
    // setrefId(ref_id);
    setModal(true);
  };

  const handleNavigate = (id) => {
    navigate(`/add-hospital/${id}`);
  };

  return (
    <div>
      <h2>Create Cohort</h2>
      <div className="d-flex justify-content-between m-3">
        <div className={style.create} onClick={() => setCreateModal(true)}>
          Create <PlusOutlined />
        </div>
      </div>

      <section style={{ maxWidth: "90%", margin: "auto", boxShadow: "1px 2px 10px rgba(112, 144, 176, 0.25)" }}>
        {loading && <LinearLoader />}

        <Table borderless responsive className="" hover>
          <thead>
            <tr className={style.TableHeadRow}>
              {headers.map((row) => {
                return <td key={row.key}>{row.label} </td>;
              })}
            </tr>
          </thead>
          {allHospitalCohort?.map((item, index) => {
            return (
              <tbody>
                <tr className={style.TableBodyRow} key={index}>
                  <td
                    style={{
                      width: "12vw",
                      verticalAlign: "middle",
                      padding: "10px",
                    }}
                  >
                    {item?.id}
                  </td>
                  <td
                    style={{
                      width: "20vw",
                      verticalAlign: "middle",
                      padding: "10px",
                    }}
                  >
                    {item?.name}
                  </td>

                  <td
                    style={{
                      width: "12vw",
                      verticalAlign: "middle",
                      padding: "10px",
                    }}
                  >
                    {item?.created}
                  </td>

                  <td style={{ width: "15vw" }}>
                    <button
                      className={`${style.btnD}`}
                      style={{ marginRight: "6px" }}
                      onClick={() => handleNavigate(item.id)}
                    >
                      Edit
                    </button>
                    <button
                      style={{ marginLeft: "6px" }}
                      className={`${style.btn}`}
                      onClick={() => handleRow(item)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            );
          })}
        </Table>
        <ConfirmationModal
          open={createModal}
          handleClose={() => setCreateModal(false)}
          closemodal={() => setCreateModal(false)}
          bgcolor="white"
          width="45vw"
          instruction={
            <CreateForm
              loading={loading}
              handleSuccessPost={handleSuccessPost}
              refId={refId}
              onClickYes={() => {}}
              setCreateModal={setCreateModal}
            />
          }
        />
        {modal && (
          <Modal
            setModal={setModal}
            dataItem={dataItem}
            handleSuccessPost={handleSuccessPost}
          />
        )}
      </section>
    </div>
  );
};

export default NotifyNerveScreen;

const Modal = ({ setModal, dataItem, handleSuccessPost }) => {
  const dispatch = useDispatch();
  const { id } = dataItem;

  const [showSpinner, setShowSpinner] = useState(false);

  const handleYesButton = () => {
    // dispatch(notifyNervePost(dataItem));
    dispatch(deleteNervePost(id));
    setShowSpinner(true);
    setTimeout(() => {
      setShowSpinner(false);
      setModal(false);
      handleSuccessPost();
      // setIsDeleted(true)
    }, 1500);
  };
  const handleNoButton = () => {
    setModal(false);
  };
  const handleOverlayClick = () => {};
  return (
    <div className={style.overlay} onClick={handleOverlayClick}>
      <div className={style.modalContent}>
        <h4 className={style.headerModal}>Do you want to delete?</h4>
        <div className={style.btnContainer}>
          <button className={style.button} onClick={handleYesButton}>
            {showSpinner ? <SyncOutlined spin /> : "Yes"}
          </button>
          <button className={style.button} onClick={handleNoButton}>
            No
          </button>
        </div>
      </div>
    </div>
  );
};
